<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <DFormRow
            :label="__('settings.market_regions.name')"
            :is-required="true"
            :error="errors.name"
            :hint="__('settings.market_regions.name_hint')"
        >
            <DInput
                id="name"
                v-model="form.name"
                :placeholder="__('settings.market_regions.name')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.countries')"
            :is-required="marketRegion?.countries?.length !== 0"
            :error="errors.countries"
            :hint="__('settings.market_regions.countries_hint')"
        >
            <!-- DMultiSelect (which use CMultiSelect) have a bug with :disabled prop when :multiple="true", does not work. When you set :disabled="true"
             you can click on X in options and also you can click on icon on dropdown which will open options list.
             For that reason I will wrap DMultiSelect in div and I will disable div so I can simulate same visual result on GUI-->
            <div :class="marketRegion?.countries?.length === 0 ? 'disableDiv' : ''">
                <DMultiSelect
                    id="countries"
                    :options="selectedCountriesOptions"
                    :selection="true"
                    :multiple="true"
                    selection-type="tags"
                    :search="true"
                    :disabled="marketRegion?.countries?.length === 0"
                    @update="updateSelectedCountries"
                />
            </div>
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.currency_code')"
            :is-required="true"
            :error="errors.currency_code"
            :hint="__('settings.market_regions.currency_code_hint')"
        >
            <DSelect
                id="currency_code"
                v-model="form.currency_code"
                :options="currencyCodes"
                :disabled="parentExists || isEdit"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.currency_code')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.currency_symbol')"
            :error="errors.currency_symbol"
            :hint="__('settings.market_regions.currency_symbol_hint')"
        >
            <DSelect
                id="currency_symbol"
                v-model="form.currency_symbol"
                :options="currencySymbols"
                :disabled="parentExists || isEdit"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.currency_symbol')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.price_type')"
            :error="errors.price_type"
            :hint="__('settings.market_regions.price_type_hint')"
        >
            <DSelect
                id="price_type"
                v-model="form.price_type"
                :options="priceTypeOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.price_type')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.price_display_period')"
            :error="errors.price_display_period"
            :hint="__('settings.market_regions.price_display_period_hint')"
        >
            <DSelect
                id="price_display_period"
                v-model="form.price_display_period"
                :options="priceDisplayPeriodOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.price_display_period')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.price_symbol_position')"
            :is-required="true"
            :error="errors.price_symbol_position"
            :hint="__('settings.market_regions.price_symbol_position_hint')"
        >
            <DSelect
                id="price_symbol_position"
                v-model="form.price_symbol_position"
                :options="priceSymbolPositionOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.price_symbol_position')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.price_symbol_separator')"
            :is-required="true"
            :hint="__('settings.market_regions.price_symbol_separator_hint')"
            :error="errors.price_symbol_separator"
        >
            <DSelect
                id="price_symbol_separator"
                v-model="form.price_symbol_separator"
                :options="priceSymbolSeparatorOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.price_symbol_separator')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.price_decimal_separator')"
            :is-required="true"
            :error="errors.price_decimal_separator"
            :hint="__('settings.market_regions.price_decimal_separator_hint')"
        >
            <DSelect
                id="price_decimal_separator"
                v-model="form.price_decimal_separator"
                :options="priceDecimalSeparatorOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.price_decimal_separator')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.price_thousands_separator')"
            :is-required="true"
            :error="errors.price_thousands_separator"
            :hint="__('settings.market_regions.price_thousands_separator_hint')"
        >
            <DSelect
                id="price_thousands_separator"
                v-model="form.price_thousands_separator"
                :options="priceThousandsSeparatorOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.price_thousands_separator')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.decimal_places')"
            :is-required="true"
            :hint="__('settings.market_regions.decimal_places_hint')"
            :error="errors.decimal_places"
        >
            <DSelect
                id="decimal_places"
                v-model="form.decimal_places"
                :options="decimalPlacesOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.decimal_places')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.parent_id')"
            :error="errors.parent_id"
            :hint="__('settings.market_regions.parent_id_hint')"
        >
            <DSelect
                id="parent_id"
                v-model="form.parent_id"
                :options="parentOptions"
                :disabled="isEdit || marketRegion?.countries?.length === 0"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.parent_id')"
                @update:value="updateMarketRegion"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.bank_account_id')"
            :is-required="true"
            :error="errors.bank_account_id"
            :hint="__('settings.market_regions.bank_account_id_hint')"
        >
            <DSelect
                id="bank_account_id"
                v-model="form.bank_account_id"
                :options="bankAccountOptions"
                add-input-classes="bg-light"
                :placeholder="__('settings.market_regions.bank_account_id')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.market_regions.minimum_invoice_amount_enabled')"
            :is-required="false"
            :hint="__('settings.market_regions.minimum_invoice_amount_enabled_hint')"
        >
            <DSwitch
                id="minimum_invoice_amount_enabled"
                v-model="form.minimum_invoice_amount_enabled"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            v-if="form.minimum_invoice_amount_enabled"
            :label="__('settings.market_regions.minimum_invoice_amount')"
            :is-required="true"
            :error="errors.minimum_invoice_amount"
            :hint="__('settings.market_regions.minimum_invoice_amount_hint')"
        >
            <DInput
                id="minimum_invoice_amount"
                v-model="form.minimum_invoice_amount"
                name="minimum_invoice_amount"
                type="number"
                min="0"
                :placeholder="__('settings.market_regions.minimum_invoice_amount')"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            :cancel-route="cancelRoute"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const props = defineProps({
    marketRegion: {
        type: Object,
        default () { return {} }
    },
    countries: {
        type: Array,
        default: () => { return [] }
    },
    currencyCodes: {
        type: Array,
        default: () => { return [] }
    },
    currencySymbols: {
        type: Array,
        default: () => { return [] }
    },
    priceTypeOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceDisplayPeriodOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceSymbolPositionOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceSymbolSeparatorOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceDecimalSeparatorOptions: {
        type: Array,
        default: () => { return [] }
    },
    priceThousandsSeparatorOptions: {
        type: Array,
        default: () => { return [] }
    },
    decimalPlacesOptions: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    parentOptions: {
        type: Array,
        default: () => { return [] }
    },
    bankAccountOptions: {
        type: Array,
        default: () => { return [] }
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    id: props.marketRegion.id ?? null,
    name: props.marketRegion.name ?? null,
    countries: props.marketRegion.countries ?? [],
    currency_code: props.marketRegion.currency_code ?? null,
    currency_symbol: props.marketRegion.currency_symbol ?? null,
    price_type: props.marketRegion.price_type ?? 'net',
    price_display_period: props.marketRegion.price_display_period ?? 'year',
    price_symbol_position: props.marketRegion.price_symbol_position ?? null,
    // '__unset__' is PriceSymbolSeparatorEnum::UNSET, the value of the select's empty option. It
    // cannot be null here, because null renders as '' - which is the Empty option's own value.
    price_symbol_separator: props.marketRegion.price_symbol_separator ?? '__unset__',
    price_decimal_separator: props.marketRegion.price_decimal_separator ?? null,
    price_thousands_separator: props.marketRegion.price_thousands_separator ?? null,
    decimal_places: props.marketRegion.decimal_places ?? 3,
    parent_id: props.marketRegion.parent_id ?? null,
    bank_account_id: props.marketRegion.bank_account_id ?? null,
    minimum_invoice_amount_enabled: props.marketRegion.minimum_invoice_amount_enabled ?? false,
    minimum_invoice_amount: props.marketRegion.minimum_invoice_amount ?? null
})

const cancelRoute = computed(() => route('settings.market-regions.index'))

// Currency & parent of an existing market region are immutable
const isEdit = computed(() => (props.marketRegion?.id ?? null) !== null)

const parentExists = computed(() => (form.parent_id ?? null) !== null && (form.parent_id ?? null) !== '')

const selectedCountriesOptions = computed(() => {
    return props.countries.map((option) => ({ ...option, selected: form.countries.includes(option.value) }))
})

function updateSelectedCountries (values) {
    form.countries = values
}
function updateMarketRegion (value) {
    const parentMarketRegion = usePage().props.marketRegions[value] ?? null

    form.currency_code = parentMarketRegion?.currency_code
    form.currency_symbol = parentMarketRegion?.currency_symbol
}

const submitForm = () => {
    emit('form-submitted', form)
}

</script>

<style lang="scss" scoped>
.disableDiv {
    pointer-events: none;
}
</style>
